import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Button } from '@saucelabs/sl-component-buttons';
import { ResetAll } from '@saucelabs/sl-component-performance-preview';
import { Loader } from '@saucelabs/sl-component-loader';

import { REGRESSION_CONTENT } from '../constants';
import Styles from './RegressionListBottom.styles';

const context = classNames.bind(Styles);

const RegressionListBottom = ({
  onActionButtonClick,
  regressionType,
  onResetClick,
  loading,
  onResetSuccess,
  disableActionButton,
  loadingReset,
  failureReset,
}) => {
  const [isResetVisible, updateReset] = useState(false);
  const showReset = () => updateReset(true);
  const hideReset = () => updateReset(false);

  return (
    <footer className={Styles['regression-bottom-bar']}>
      <Button
        className={context('action-button', {
          'with-loading': loading,
        })}
        disabled={loading || disableActionButton}
        material
        onClick={onActionButtonClick}
        raised
      >
        <Loader
          show={loading}
          text={REGRESSION_CONTENT.getIn([regressionType, 'loadingLabel'])}
        >
          {REGRESSION_CONTENT.getIn([regressionType, 'label'])}
        </Loader>
      </Button>
      <p className={Styles['reset-text']}>
        If you think the regression is due to an error, you may
        {' '}
        <Button
          category="primary"
          className={Styles['reset-button']}
          material
          onClick={showReset}
        >
          Reset All.
        </Button>
      </p>
      <ResetAll
        failure={failureReset}
        loading={loadingReset}
        onClose={hideReset}
        onResetClick={onResetClick}
        onResetSuccess={onResetSuccess}
        show={isResetVisible}
      />
    </footer>
  );
};

RegressionListBottom.propTypes = {
  disableActionButton: PropTypes.bool.isRequired,
  failureReset: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  loadingReset: PropTypes.bool.isRequired,
  onActionButtonClick: PropTypes.func.isRequired,
  onResetClick: PropTypes.func.isRequired,
  onResetSuccess: PropTypes.func.isRequired,
  regressionType: PropTypes.string.isRequired,
};

RegressionListBottom.defaultProps = {
  failureReset: null,
};

export default RegressionListBottom;
